import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DepartmentConfig } from "@/types";
import { saveDepartmentConfig, getDepartmentConfig } from "@/services/storage";

export const OnboardingPage: React.FC = () => {
  const navigate = useNavigate();
  const existing = getDepartmentConfig();
  const isEditing = !!existing;

  const [cityName, setCityName] = useState(existing?.cityName || "");
  const [departmentName, setDepartmentName] = useState(
    existing?.departmentName || "",
  );
  const [shortName, setShortName] = useState(existing?.shortName || "");
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!cityName.trim()) {
      setError("请输入城市名称");
      return;
    }
    if (!departmentName.trim()) {
      setError("请输入管理部门名称");
      return;
    }

    const config: DepartmentConfig = {
      cityName: cityName.trim(),
      departmentName: departmentName.trim(),
      shortName: shortName.trim() || cityName.trim(),
    };

    saveDepartmentConfig(config);
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* 顶部 */}
      <div className="bg-red-700 text-white px-4 py-6">
        {isEditing && (
          <button onClick={() => navigate(-1)} className="mb-3 -ml-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 18l-6-6 6-6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        )}
        <div className="flex items-center justify-center mb-2">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h1 className="text-xl font-bold text-center">燃气安全检查系统</h1>
        <p className="text-center text-red-200 text-sm mt-2">
          {isEditing ? "修改管理部门信息" : "首次使用，请设置管理部门信息"}
        </p>
      </div>

      {/* 表单 */}
      <div className="flex-1 px-4 py-6">
        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-xl p-5 space-y-4 shadow-sm"
        >
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 px-3 py-2 rounded-lg text-sm">
              {error}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              城市名称 <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={cityName}
              onChange={(e) => {
                setCityName(e.target.value);
                setError("");
              }}
              placeholder="例如：南昌市"
              className="w-full px-3 py-2.5 border border-gray-200 rounded-lg focus:border-red-500 focus:outline-none text-gray-800"
              autoFocus
            />
            <p className="text-xs text-gray-400 mt-1">
              将用于报告标题，如"南昌市燃气安全检查报告"
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              管理部门全称 <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={departmentName}
              onChange={(e) => {
                setDepartmentName(e.target.value);
                setError("");
              }}
              placeholder="例如：南昌市城市管理局"
              className="w-full px-3 py-2.5 border border-gray-200 rounded-lg focus:border-red-500 focus:outline-none text-gray-800"
            />
            <p className="text-xs text-gray-400 mt-1">将显示在报告底部署名处</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              部门简称
            </label>
            <input
              type="text"
              value={shortName}
              onChange={(e) => setShortName(e.target.value)}
              placeholder="例如：南昌城管"
              className="w-full px-3 py-2.5 border border-gray-200 rounded-lg focus:border-red-500 focus:outline-none text-gray-800"
            />
            <p className="text-xs text-gray-400 mt-1">
              用于系统内部显示，不填则使用城市名
            </p>
          </div>

          <button
            type="submit"
            className="w-full bg-red-600 text-white py-3 rounded-lg font-medium hover:bg-red-700 active:bg-red-800 transition-colors"
          >
            {isEditing ? "保存修改" : "开始使用"}
          </button>
        </form>
      </div>
    </div>
  );
};
